import React, { useEffect, useState } from 'react'

import { Link, useLocation, useParams } from 'react-router-dom';

import { Modal, notification, Progress } from 'antd';
// import ViewMoreTitle from '../../Web/Project/SubMenu/Tasks/Components/viewMoreTitle';


import ToggleUp from '../../../../../Components/Icons/ToggleUp';
import ToggleDown from '../../../../../Components/Icons/ToggleDown';

import DeleteIcon from '../../../../../Components/Icons/Delete';
import { ExclamationCircleFilled } from '@ant-design/icons';
import axiosInstance from '../../../../../Services/axiosCommon';

import CreateSubMaterialPro from '../../../../Web/Project/SubMenu/Costing/Material/CreateSubMaterialPro';
import MobileMaterialData from './MaterialData';


function MobileTitleMaterialData({rowData,getData,itemsCategory,Division,Activity,Unit}) {
  const location = useLocation();
  
    // const {value:Type ,getData:  refManPowerType} = useFetchMataData(`/dropdown/dropdown-details/`,'ManPowerType')
   
  const { officeId,projectId } = useParams();
  const searchQuery= location.state?.searchQuery
  const currentPage= location.state?.currentPage
  const [page, setPage] = useState(currentPage||1)
    const [pageCount, setPageCount] = useState(localStorage.getItem("perPageView")||20)
   const [params, setParams] = useState({
        page: page,
        per_page: pageCount,
        search:searchQuery||"",
        category:"",
         });
 

    const [isExpanded, setIsExpanded] = useState(false);
    const { confirm } = Modal;
    const [createModalOpen, setCreateModalOpen] = useState(false);
    const [api, contextHolder] = notification.useNotification();

    
    const handleDelete = async(id,removevalue) =>{
        confirm({
            title: `Do you Want to delete '${removevalue}'?`,
            centered:true,
            width:"25%",
            icon: <ExclamationCircleFilled />,
            content: `Title ${removevalue} will be removed from 'Budget/Material'`,
            okText: 'Yes',
            cancelText: 'No',
            onOk() {
              axiosInstance.delete(`/budget-title/${id}`).then((res) => {
                if(res.status === 201||res.status === 200) {
                    getData();
                    api.success({
                      message: `Success`,
                      item:res?.data?.msg||' ',
                      placement: 'bottomRight',
                    });
                } else{
                    api.error({
                        message: `Failed`,
                        description:res?.data?.msg||'Network error',
                        placement: 'bottomRight',
                      });
                }
                })
                .catch((error) => {
                    api.error({
                        message: `Failed`,
                        description:error?.response?.data?.msg||'Sever error (or) Network error',
                        placement: 'bottomRight',
                      });
                });
            },
            onCancel() {
            },
          });
    }
 
    const handleToggle = () => {
      setIsExpanded(!isExpanded);
    };


    const userAccess = JSON.parse(localStorage.getItem("userAccess"));
    let MyTaskCreate = userAccess
      ? userAccess.some(
          (permission) => permission.permissionName == "MyTask_create"
        )
      : false;

  return (
    <div className=" bg-slate-50 rounded my-2 px-2 py-3">
    <div className=" w-full flex gap-2 items-center">
      <div className=' w-[5%]'>
      { rowData?.data?.length>0 && <div className=' w-3 rounded-md cursor-pointer text-center items-center p-0.5  ' onClick={handleToggle}>{isExpanded ?<ToggleUp/>:<ToggleDown/>}</div>}
      </div>
      <div className=' w-[55%]'>  
        {rowData?.title}
     
      </div>
      
      <div className=' w-[30%]'>
      <div className=' w-full flex gap-2 justify-end px-2 items-center'>
      <div className=" w-[13px] h-[13px] flex items-center gap-2 ">
      <div className='w-6 h-6 bg-white rounded-full flex justify-center items-center cursor-pointer' 
            onClick={() => {
              setCreateModalOpen(true);
            }}
            >
              +
            </div> 
            <div className=' cursor-pointer' onClick={() => { handleDelete(rowData?.title_ID,rowData?.title) }}>
            <DeleteIcon/>
            </div>
          </div>
   
          </div>
      </div>
      <div> 
  
      </div>
    </div>
    {isExpanded && rowData?.data.map((item,i)=>(
                <MobileMaterialData taskData={item||""} key={i} getData={getData} itemsCategory={itemsCategory} projectId={projectId} data={rowData} Division={Division} Activity={Activity} Unit={Unit} />
                
              ))}
              <CreateSubMaterialPro
       open={createModalOpen}
       onCancel={() => {
         setCreateModalOpen(false);
       }}
       getData={getData}
       projectId={projectId}
       itId={rowData?.title_ID}
      itemsCategory={itemsCategory}
      Division={Division}
       Activity={Activity}
       Unit={Unit}
      //  itemsCategory={itemsCategory}
       />
      
  </div>
  
  
  )
  
}

export default MobileTitleMaterialData;